package com.alpha.showcase.common.ui.config

import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.displayCutout
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBars
import androidx.compose.foundation.background
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.outlined.ArrowBack
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.pointer.PointerEventPass
import androidx.compose.ui.input.pointer.PointerEventType
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.max
import com.alpha.showcase.common.networkfile.storage.TYPE_FTP
import com.alpha.showcase.common.networkfile.storage.TYPE_SFTP
import com.alpha.showcase.common.networkfile.storage.TYPE_SMB
import com.alpha.showcase.common.networkfile.storage.TYPE_UNKNOWN
import com.alpha.showcase.common.networkfile.storage.TYPE_WEBDAV
import com.alpha.showcase.common.networkfile.storage.remote.GitHubSource
import com.alpha.showcase.common.networkfile.storage.remote.GallerySource
import com.alpha.showcase.common.networkfile.storage.remote.PexelsSource
import com.alpha.showcase.common.networkfile.storage.remote.TMDBSource
import com.alpha.showcase.common.networkfile.storage.remote.TYPE_GITHUB
import com.alpha.showcase.common.networkfile.storage.remote.TYPE_GALLERY
import com.alpha.showcase.common.networkfile.storage.remote.TYPE_PEXELS
import com.alpha.showcase.common.networkfile.storage.remote.TYPE_TMDB
import com.alpha.showcase.common.networkfile.storage.remote.TYPE_UNSPLASH
import com.alpha.showcase.common.networkfile.storage.remote.UnSplashSource
import com.alpha.showcase.common.networkfile.storage.getType
import com.alpha.showcase.common.networkfile.storage.remote.AlbumSource
import com.alpha.showcase.common.networkfile.storage.remote.Ftp
import com.alpha.showcase.common.networkfile.storage.remote.GiteeSource
import com.alpha.showcase.common.networkfile.storage.remote.ImmichSource
import com.alpha.showcase.common.networkfile.storage.remote.MTPhotoSource
import com.alpha.showcase.common.networkfile.storage.remote.OAuthRcloneApi
import com.alpha.showcase.common.networkfile.storage.remote.RcloneRemoteApi
import com.alpha.showcase.common.networkfile.storage.remote.RemoteApi
import com.alpha.showcase.common.networkfile.storage.remote.RssSource
import com.alpha.showcase.common.networkfile.storage.remote.S3Source
import com.alpha.showcase.common.networkfile.storage.remote.Sftp
import com.alpha.showcase.common.networkfile.storage.remote.Smb
import com.alpha.showcase.common.networkfile.storage.remote.TYPE_ALBUM
import com.alpha.showcase.common.networkfile.storage.remote.TYPE_GITEE
import com.alpha.showcase.common.networkfile.storage.remote.TYPE_IMMICH
import com.alpha.showcase.common.networkfile.storage.remote.TYPE_MTPHOTO
import com.alpha.showcase.common.networkfile.storage.remote.TYPE_RSS
import com.alpha.showcase.common.networkfile.storage.remote.TYPE_S3
import com.alpha.showcase.common.networkfile.storage.remote.WebDav
import showcaseapp.composeapp.generated.resources.Res
import com.alpha.showcase.common.repo.isAlbumPlatformUnavailable
import com.alpha.showcase.common.ui.source.SourceViewModel
import com.alpha.showcase.common.ui.source.localizedDisplayName
import com.alpha.showcase.common.ui.view.TextTitleLarge
import com.alpha.showcase.common.ui.view.rememberMobileHaptic
import com.alpha.showcase.common.utils.ToastUtil
import kotlinx.coroutines.CancellationException
import org.jetbrains.compose.resources.stringResource
import showcaseapp.composeapp.generated.resources.add
import showcaseapp.composeapp.generated.resources.add_success
import showcaseapp.composeapp.generated.resources.album_apple_web_unsupported
import showcaseapp.composeapp.generated.resources.connection_failed
import showcaseapp.composeapp.generated.resources.connection_successful
import showcaseapp.composeapp.generated.resources.edit
import showcaseapp.composeapp.generated.resources.save_success
import showcaseapp.composeapp.generated.resources.source
import showcaseapp.composeapp.generated.resources.source_name_already_exists
import showcaseapp.composeapp.generated.resources.unsupport_type
import showcaseapp.composeapp.generated.resources.web_source_browser_access_error
import showcaseapp.composeapp.generated.resources.webdav_browser_access_error
import isMobile

@Composable
fun ConfigScreen(type: Int, editSource: RemoteApi? = null, onSave: (() -> Unit)? = null) {
    ConfigScreenTitle(type = type, editMode = editSource != null, onBack = onSave) {
        ConfigContent(type, editSource, onSave)
    }
}

@Composable
fun ConfigScreenTitle(
    type: Int,
    editMode: Boolean = false,
    onBack: (() -> Unit)? = null,
    content: @Composable ColumnScope.() -> Unit
) {
    val density = LocalDensity.current
    val displayCutoutTop = (WindowInsets.displayCutout.getTop(density) / density.density).dp
    val statusBarTop = (WindowInsets.statusBars.getTop(density) / density.density).dp
    val headerTopPadding = max(36.dp, max(displayCutoutTop, statusBarTop) + 12.dp)
    val title = "${if (editMode) stringResource(Res.string.edit) else stringResource(Res.string.add)} ${getType(type).localizedDisplayName()} ${stringResource(Res.string.source)}"

    Surface(Modifier.fillMaxWidth()) {
        Column(Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
            Box(
                modifier = Modifier.fillMaxWidth().padding(16.dp, headerTopPadding, 16.dp, 0.dp)
            ) {
                IconButton(
                    onClick = { onBack?.invoke() },
                    modifier = Modifier.align(Alignment.CenterStart).size(40.dp)
                ) {
                    Icon(
                        imageVector = Icons.AutoMirrored.Outlined.ArrowBack,
                        contentDescription = "Back"
                    )
                }
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.Center,
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    TextTitleLarge(text = title)
                }
            }

            content()
        }
    }
}

@Composable
fun ConfigContent(
    type: Int = TYPE_UNKNOWN,
    editRemote: RemoteApi? = null,
    onSave: (() -> Unit)? = null,
    viewModel: SourceViewModel = SourceViewModel
) {
    val focusManager = LocalFocusManager.current
    val editMode = editRemote != null
    var savingSource by remember { mutableStateOf(false) }
    val performHaptic = rememberMobileHaptic()
    val loadingOverlayInteraction = remember { MutableInteractionSource() }
    val connectionFailedMessage = stringResource(Res.string.connection_failed)
    val browserAccessMessage = stringResource(Res.string.web_source_browser_access_error)
    val webDavBrowserAccessMessage = stringResource(Res.string.webdav_browser_access_error)
    val appleWebUnsupportedMessage = stringResource(Res.string.album_apple_web_unsupported)

    fun browserConnectionFailureMessage(remoteApi: RemoteApi): String =
        if (remoteApi is WebDav) webDavBrowserAccessMessage else browserAccessMessage

    fun validateSourceName(remoteApi: RemoteApi): Result<Any>? {
        if (viewModel.checkDuplicateName(remoteApi.name) || editMode) return null
        ToastUtil.error(Res.string.source_name_already_exists)
        return Result.failure(Exception(Res.string.source_name_already_exists.key))
    }
    val onTestClick: suspend (RemoteApi) -> Result<Any> = { remoteApi ->
        validateSourceName(remoteApi) ?: run {
            val checkConnection = try {
                viewModel.checkConnection(remoteApi)
            } catch (error: CancellationException) {
                throw error
            } catch (error: Throwable) {
                Result.failure(error)
            }
            if (checkConnection.isSuccess) {
                ToastUtil.success(Res.string.connection_successful)
                Result.success(checkConnection.getOrNull()!!)
            } else {
                val error = checkConnection.exceptionOrNull() ?: Exception(connectionFailedMessage)
                val message = when {
                    error.isAlbumPlatformUnavailable() -> appleWebUnsupportedMessage
                    browserConnectionProblem(error) != null -> browserConnectionFailureMessage(remoteApi)
                    else -> connectionFailedMessage
                }
                ToastUtil.error(message)
                Result.failure(error)
            }
        }
    }
    // MTPhotoConfigPage has already authenticated and loaded the album list before
    // invoking this callback. Repeating checkConnection would issue a second GET and
    // could leave the button spinning if that redundant request became half-open.
    val onMTPhotoPreflightComplete: suspend (RemoteApi) -> Result<Any> = { remoteApi ->
        validateSourceName(remoteApi) ?: run {
            ToastUtil.success(Res.string.connection_successful)
            Result.success(true)
        }
    }
    val onSaveClick: suspend (RemoteApi) -> Unit = save@{ remoteApi ->
        if (savingSource) return@save
        savingSource = true
        try {
            val saved = editRemote?.let { previous ->
                viewModel.replaceSourceList(previous, remoteApi)
            } ?: viewModel.addSourceList(remoteApi)
            if (saved) {
                ToastUtil.success(if (editRemote == null) Res.string.add_success else Res.string.save_success)
                performHaptic()
                onSave?.invoke()
            } else {
                ToastUtil.error(Res.string.source_name_already_exists)
            }
        } catch (error: CancellationException) {
            throw error
        } catch (error: Exception) {
            error.printStackTrace()
            ToastUtil.error(error.message ?: "Failed to save source")
        } finally {
            savingSource = false
        }
    }

    val uriHandler = LocalUriHandler.current


    val onSelectPath: suspend (RcloneRemoteApi, String) -> Result<Any>? =
        { rcloneRemote, path ->
            viewModel.getFilesItemList(rcloneRemote, path)
        }

    val dismissKeyboardModifier = if (isMobile()) {
        Modifier.pointerInput(focusManager) {
            awaitPointerEventScope {
                while (true) {
                    val event = awaitPointerEvent(PointerEventPass.Final)
                    if (event.type == PointerEventType.Release && event.changes.all { !it.isConsumed }) {
                        focusManager.clearFocus(force = true)
                    }
                }
            }
        }
    } else {
        Modifier
    }

    Box(modifier = Modifier.fillMaxWidth().then(dismissKeyboardModifier)) {
        when (type) {
            TYPE_SMB -> {
                SmbConfigPage(
                    editRemote as Smb?,
                    onTestClick = onTestClick,
                    onSaveClick = onSaveClick,
                    onSelectPath = onSelectPath
                )
            }

            TYPE_FTP -> {
                FtpConfigPage(
                    editRemote as Ftp?,
                    onTestClick = onTestClick,
                    onSaveClick = onSaveClick,
                    onSelectPath = onSelectPath
                )
            }

            TYPE_SFTP -> {
                SftpConfigPage(
                    editRemote as Sftp?,
                    onTestClick = onTestClick,
                    onSaveClick = onSaveClick,
                    onSelectPath = onSelectPath
                )
            }

            TYPE_WEBDAV -> {
                WebdavConfigPage(
                    editRemote as WebDav?,
                    onTestClick = onTestClick,
                    onSaveClick = onSaveClick
                )
            }

            TYPE_GITHUB -> {
                GithubConfigPage(
                    editRemote as GitHubSource?,
                    onTestClick = onTestClick,
                    onSaveClick = onSaveClick
                )
            }

            TYPE_TMDB -> {
                TMDBConfigPage(
                    editRemote as TMDBSource?,
                    onTestClick = onTestClick,
                    onSaveClick = onSaveClick
                )
            }


            TYPE_UNSPLASH -> {
                UnsplashConfigPage(
                    unsplashSource = editRemote as UnSplashSource?,
                    onTestClick = onTestClick,
                    onSaveClick = onSaveClick
                )
            }

            TYPE_PEXELS ->{
                PexelsConfigPage(
                    pexelsSource = editRemote as PexelsSource?,
                    onTestClick = onTestClick,
                    onSaveClick = onSaveClick
                )
            }

            TYPE_GITEE -> {
                GiteeConfigPage(
                    giteeSource = editRemote as GiteeSource?,
                    onTestClick = onTestClick,
                    onSaveClick = onSaveClick,
                )
            }

            TYPE_IMMICH -> {
                ImmichConfigPage(
                    immichSource = editRemote as ImmichSource?,
                    onTestClick = onTestClick,
                    onSaveClick = onSaveClick,
                )
            }

            TYPE_MTPHOTO -> {
                MTPhotoConfigPage(
                    mtPhotoSource = editRemote as MTPhotoSource?,
                    onTestClick = onMTPhotoPreflightComplete,
                    onSaveClick = onSaveClick,
                )
            }

            TYPE_ALBUM -> {
                AlbumConfigPage(
                    albumSource = editRemote as AlbumSource?,
                    onTestClick = onTestClick,
                    onSaveClick = onSaveClick
                )
            }

            TYPE_GALLERY -> {
                GalleryConfigPage(
                    gallerySource = editRemote as GallerySource?
                )
            }

            TYPE_S3 -> {
                S3ConfigPage(
                    s3Source = editRemote as S3Source?,
                    onTestClick = onTestClick,
                    onSaveClick = onSaveClick,
                )
            }

            TYPE_RSS -> {
                RssConfigPage(
                    rssSource = editRemote as RssSource?,
                    onTestClick = onTestClick,
                    onSaveClick = onSaveClick,
                )
            }

            else -> {

                LaunchedEffect(Unit){
                    ToastUtil.error(Res.string.unsupport_type)
                    // todo
                }

            }

        }

        if (savingSource) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(androidx.compose.material3.MaterialTheme.colorScheme.scrim.copy(alpha = 0.35f))
                    .clickable(
                        interactionSource = loadingOverlayInteraction,
                        indication = null
                    ) {},
                contentAlignment = Alignment.Center
            ) {
                CircularProgressIndicator(
                    modifier = Modifier.size(36.dp)
                )
            }
        }
    }
}
